import { useCallback } from 'react';

import { getLocation } from '@change-corgi/core/window';
import { useTracking } from '@change-corgi/core-react/tracking';

type Result = ModelHookResult<
	undefined,
	{
		reload: () => void;
	}
>;

export function useErrorMessage(): Result {
	const track = useTracking();

	return {
		actions: {
			reload: useCallback(() => {
				void track('search_results_reload_page');
				getLocation().reload();
			}, [track]),
		},
	};
}
